export default "__VITE_ASSET__063fe30f__"